import { Image } from "./image";
import { SITE_DATA_PARTITIONS } from "./siteTable";

export type ArtKey = {
  PK: typeof SITE_DATA_PARTITIONS.ART;
  SK: string;
};

export type ArtKeyComponents = {
  type: typeof SITE_DATA_PARTITIONS.ART;
  slug: string;
};

export type ArtGSI1KeyComponents = {
  type: typeof SITE_DATA_PARTITIONS.ART;
};

export const MEDIUM_TYPE = {
  ACRYLIC: { key: "acrylic", label: "Acrylic" },
  INK: { key: "ink", label: "Ink" },
  CANVAS: { key: "canvas", label: "Canvas" },
  CHARCOAL: { key: "charcoal", label: "Charcoal" },
  PARCHMENT: { key: "parchment", label: "Parchment" },
} as const;
export type MediumType = (typeof MEDIUM_TYPE)[keyof typeof MEDIUM_TYPE]["key"];

export const CURRENCY_TYPE = {
  USD: { key: "usd", label: "USD", symbol: "$" },
} as const;
export type CurrencyType =
  (typeof CURRENCY_TYPE)[keyof typeof CURRENCY_TYPE]["key"];

export type ArtData = ArtKeyComponents &
  ArtGSI1KeyComponents & {
    title: string;
    dimensions: {
      w: number;
      h: number;
      d: number;
      unit: "in";
    };
    mediums?: MediumType[];
    description?: string;
    images?: Image[];
    price?: number;
    currency?: CurrencyType;
    author?: string;
    isInProgress?: boolean;
    isPublic?: boolean;
    orderSlug?: string;
  };
export type ArtDBData = ArtKey & ArtData;
